import { API_GET_ANALYSIS_IMPORT, API_GET_ANALYSIS_IMPORT_FILE, API_GET_CATALOG_LOGS } from "actions/analysisService";
export function getAnalysisImport() {
	return {
		type: API_GET_ANALYSIS_IMPORT,
		payload: {
			request: {
				url: `/analysisImport`,
			},
		},
	};
}

export function getAnalysisImportFile() {
	return {
		type: API_GET_ANALYSIS_IMPORT_FILE,
		payload: {
			request: {
				url: `/analysisImportFile`,
			},
		},
	};
}

export function getCatalogLogs() {
	return {
		type: API_GET_CATALOG_LOGS,
		payload: {
			request: {
				url: `/logs/ca`,
			},
		},
	};
}
